/* 布局 */
//前台
import Layout from "@views/layout";

const plastucurriculumclassRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "plastucurriculumclass/list",
        name: "PLASTUCURRICULUMCLASS",
        meta: {
            title: "学生课程分类",
        },
        component: () => import("@views/business/plastucurriculumclass/index.vue"),
    },
        ],
};

export default plastucurriculumclassRouter;
